import { render, staticRenderFns } from "./ChatDrawer.vue?vue&type=template&id=310cac39&scoped=true&"
import script from "./ChatDrawer.vue?vue&type=script&lang=js&"
export * from "./ChatDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ChatDrawer.vue?vue&type=style&index=0&id=310cac39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310cac39",
  null
  
)

export default component.exports